// @ts-nocheck
/* eslint-disable */
export const docShieldIcon = {
    data: ``,
    name: 'doc-shield' as const
};